import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./components/Login";
import AutoRegister from "./components/AutoRegister";
import Profile from "./Profile";
import Newsletter from "./Newsletter";
import RegisterWebpush from "./components/RegisterWebpush";
import Test from "./Test";

const router = createBrowserRouter(
  [
    {
      path: "/Login",
      element: <Login />,
    },
    {
      path: "/test",
      element: <Test />,
    },
    {
      path: "/autoregister",
      element: <AutoRegister />,
    },
    {
      path: "/registerwebpush",
      element: (
        <ProtectedRoute>
          <RegisterWebpush />
        </ProtectedRoute>)
    },
    {
      path: "/profile",
      element: (
        <ProtectedRoute>
          <Profile />
        </ProtectedRoute>
      ),
    },
    {
      path: "/AnzeigeTafel",
      element: <App />,
    },

    {
      path: "/Newsletter",
      element: <Newsletter />,
    },
    {
      path: "/booking",
      element: (
        <ProtectedRoute>
          <App />
        </ProtectedRoute>
      ),

    },
    {
      path: "/",

      element: <Newsletter />,


    },
  ]
  // {
  //   basename: "/app",
  // }
);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
